
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deployments",
      function () {
        return require("private-next-pages/deployments/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deployments"])
      });
    }
  